// Mono-uppercase breadcrumb trail. Sits at the top of every authenticated
// page below the sidebar shell. Pure presentation; no react-router
// dependency -- callers pass `Trail[]` and we render.
//
// Usage:
//   <Crumbs trail={["Dashboard"]} />
//   <Crumbs trail={["Reports", "1:1 with Akowally · 06 May"]} />

export type Crumb = string | { label: string; to: string };

export function Crumbs({ trail }: { trail: ReadonlyArray<Crumb> }) {
  return (
    <p className="crumbs">
      {trail.map((c, i) => {
        const isLast = i === trail.length - 1;
        const label = typeof c === "string" ? c : c.label;
        const to = typeof c === "string" ? null : c.to;
        return (
          <span key={`${label}-${i}`} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            {to && !isLast ? (
              <a href={to} style={{ color: "inherit", textDecoration: "none" }}>{label}</a>
            ) : (
              <span>{label}</span>
            )}
            {!isLast ? <span className="sep" aria-hidden="true">/</span> : null}
          </span>
        );
      })}
    </p>
  );
}
